module.exports = __webpack_public_path__ + "files/23d5a11416fbff26179b131f89d1a21b.svg";